import React from "react";
import { useApi } from "../hooks/useApi";

const card = { background: "#0d1224", border: "1px solid #1e2a45", borderRadius: "10px", padding: "14px" };

export default function Headlines() {
  const { data, loading } = useApi("/intelligence", 120000);
  const headlines = data?.headlines || [];

  return (
    <div style={card}>
      <div style={{ fontWeight: 600, color: "#94a3b8", marginBottom: "10px", fontSize: "13px" }}>
        📰 Market Headlines
        <span style={{ fontSize: "10px", color: "#334155", marginLeft: "8px" }}>FinBERT monitored</span>
      </div>

      {loading && <div style={{ color: "#475569", fontSize: "11px" }}>Fetching headlines...</div>}

      {!loading && headlines.length === 0 && (
        <div style={{ color: "#334155", fontSize: "11px" }}>No headlines available</div>
      )}

      <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
        {headlines.map((h, i) => {
          const title = typeof h === "string" ? h : h.title;
          const url   = typeof h === "string" ? null : h.url;

          return (
            <a
              key={i}
              href={url || "#"}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "block",
                padding: "6px 8px",
                borderRadius: "6px",
                background: "#080c18",
                borderLeft: "2px solid #1e2a45",
                fontSize: "11px",
                color: "#94a3b8",
                lineHeight: "1.4",
                textDecoration: "none",
                cursor: url ? "pointer" : "default",
                transition: "border-color 0.2s, background 0.2s",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderLeftColor = "#60a5fa";
                e.currentTarget.style.background = "#0f172a";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderLeftColor = "#1e2a45";
                e.currentTarget.style.background = "#080c18";
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: "8px" }}>
                <span style={{ flex: 1 }}>{title}</span>
                {url && (
                  <span style={{ fontSize: "9px", color: "#475569", flexShrink: 0, marginTop: "2px" }}>
                    ↗
                  </span>
                )}
              </div>
            </a>
          );
        })}
      </div>
    </div>
  );
}
